import { render, staticRenderFns } from "./ApplicationDistanceEducationEdit.vue?vue&type=template&id=1367cc2c&scoped=true&"
import script from "./ApplicationDistanceEducationEdit.vue?vue&type=script&lang=js&"
export * from "./ApplicationDistanceEducationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367cc2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCheckbox,VDataTable,VForm})
